import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-white border-t border-gray-300 mt-auto" data-id="element-256">
      <div className="max-w-7xl mx-auto px-6 py-12" data-id="element-257">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-258">
          {/* Company */}
          <div data-id="element-259">
            <h3 className="font-bold text-sm mb-4" data-id="element-260">Company</h3>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-261">
              <li data-id="element-262">
                <Link to="/about" className="hover:text-[#1f2933]" data-id="element-263">
                  About Us
                </Link>
              </li>
              <li data-id="element-264">
                <Link to="/contact" className="hover:text-[#1f2933]" data-id="element-265">
                  Contact
                </Link>
              </li>
              <li data-id="element-266">
                <Link to="/careers" className="hover:text-[#1f2933]" data-id="element-267">
                  Careers
                </Link>
              </li>
              <li data-id="element-268">
                <Link to="/press" className="hover:text-[#1f2933]" data-id="element-269">
                  Press
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-270">
            <h3 className="font-bold text-sm mb-4" data-id="element-271">Resources</h3>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-272">
              <li data-id="element-273">
                <Link to="/legal-guides" className="hover:text-[#1f2933]" data-id="element-274">
                  Legal Guides
                </Link>
              </li>
              <li data-id="element-275">
                <Link to="/blog" className="hover:text-[#1f2933]" data-id="element-276">
                  Blog
                </Link>
              </li>
              <li data-id="element-277">
                <Link to="/faq" className="hover:text-[#1f2933]" data-id="element-278">
                  FAQ
                </Link>
              </li>
              <li data-id="element-279">
                <Link to="/support" className="hover:text-[#1f2933]" data-id="element-280">
                  Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-281">
            <h3 className="font-bold text-sm mb-4" data-id="element-282">Legal</h3>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-283">
              <li data-id="element-284">
                <Link to="/terms" className="hover:text-[#1f2933]" data-id="element-285">
                  Terms of Use
                </Link>
              </li>
              <li data-id="element-286">
                <Link to="/privacy" className="hover:text-[#1f2933]" data-id="element-287">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-288">
                <Link to="/accessibility" className="hover:text-[#1f2933]" data-id="element-289">
                  Accessibility
                </Link>
              </li>
              <li data-id="element-290">
                <Link to="/cookies" className="hover:text-[#1f2933]" data-id="element-291">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div data-id="element-292">
            <h3 className="font-bold text-sm mb-4" data-id="element-293">Connect</h3>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-294">
              <li data-id="element-295">
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#1f2933]" data-id="element-296">
                  Twitter
                </a>
              </li>
              <li data-id="element-297">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#1f2933]" data-id="element-298">
                  LinkedIn
                </a>
              </li>
              <li data-id="element-299">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#1f2933]" data-id="element-300">
                  Facebook
                </a>
              </li>
              <li data-id="element-301">
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#1f2933]" data-id="element-302">
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-303">
          <div className="flex items-center gap-2" data-id="element-304">
            <div className="w-6 h-6 bg-[#1f2933] rounded-sm" data-id="element-305"></div>
            <span className="font-bold" data-id="element-306">Citiplots.com</span>
          </div>
          <p className="text-xs text-gray-500 font-mono" data-id="element-307">
            © {new Date().getFullYear()} Citiplots Private Limited. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}